import React from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Collapse,
  Box,
  Typography,
  IconButton,
  Checkbox,
  Chip,
  Stack,
  Grid,
  Row,
} from "@mui/material";

const TableData = ({
  title,
  headers = [],
  datas = [],
  isTable = true,
  keyPrimary,
}) => {
  return (
    <Grid container spacing={2} style={{ marginBottom: "16px" }}>
      {title && (
        <Grid
          item
          xs={12}
          sm={12}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 2,
          }}
        >
          <Typography
            component="div"
            style={{ fontSize: "16px", fontWeight: "bolder" }}
          >
            {title}
          </Typography>
        </Grid>
      )}
      <Grid item xs={12} sm={12}>
        <Paper
          sx={{
            width: "100%",
            overflow: "hidden",
            background: "transparent",
            borderRadius: "10px",
          }}
        >
          <TableContainer
            sx={{
              width: "100%",
              overflowX: "auto",
            }}
          >
            <Table
              sx={{
                width: "100%",
                tableLayout: "fixed",
                border: "none",
                "& .MuiTableCell-root": {
                  border: "none",
                },
              }}
            >
              <TableHead
                style={{
                  background:
                    "linear-gradient(90deg, #00BB9F 0%, #6CD8BF 100%)",
                }}
              >
                <TableRow>
                  {headers.map((column, key) => {
                    return (
                      <TableCell
                        key={key}
                        style={{
                          width: `${100 / headers.length}%`,
                          minWidth: "100px",
                          color: "white",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {column.label}
                      </TableCell>
                    );
                  })}
                </TableRow>
              </TableHead>
              <TableBody style={{ backgroundColor: "white" }}>
                {datas?.length > 0 ? (
                  datas.map((row, key) => {
                    return (
                      <TableRow hover role="checkbox" tabIndex={-1} key={key}>
                        {!isTable ? (
                          <TableCell>
                            <Grid container spacing={2}>
                              <Grid
                                item
                                xs={6}
                                sm={6}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                }}
                              >
                                {row.label}
                              </Grid>
                              <Grid
                                item
                                xs={6}
                                sm={6}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                }}
                              >
                                {row.label == "สถานะ" ? (
                                  <Chip
                                    label={row.data ? "ปกติ" : "ปิดกิจการ"}
                                    style={{
                                      width: "100px",
                                      background: `${
                                        row.data ? "green" : "red"
                                      }`,
                                      color: "white",
                                      textTransform: "capitalize",
                                    }}
                                  />
                                ) : (
                                  row.data
                                )}
                              </Grid>
                            </Grid>
                          </TableCell>
                        ) : (
                          <>
                            {Object.values(row).map((cell, i) => (
                              <TableCell key={i} style={{ fontSize: "12px" }}>
                                {cell}
                              </TableCell>
                            ))}
                          </>
                        )}
                      </TableRow>
                    );
                  })
                ) : (
                  <>
                    <TableCell
                      colSpan={headers?.length}
                      style={{ textAlign: "center" }}
                    >
                      ไม่มีข้อมูล
                    </TableCell>
                  </>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default TableData;
